import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Typography, TextField, Button, Modal, Checkbox } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import {
  updateGrounding,
  getGroundingList,
  searchGroundingList,
} from "../Service";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
import { signOut } from "../../utils/signOut";
import { addLog } from "../../utils/addLog";

const styleGrayBtn = {
  backgroundColor: "#5C5C5C",
  color: "#FFFFFF",
  borderRadius: "10px",
  height: "45px",
  textTransform: "none",
  width: "100px",
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function GroundingList({ selectedGround, emptyList, listAll }) {
  const [t, i18n] = useTranslation("global");

  const [dataGrounding, setDataGrounding] = useState(
    listAll ? [] : selectedGround
  );
  const [firstLoad, setFirstLoad] = useState(true);

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };
  const [selected, setSelected] = useState([]);

  const handleSelect = (id) => {
    const newSelected = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(newSelected);
  };

  const fileRef = useRef(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };
  const handleClearSearchProduct = () => {
    setSearchInput("");
  };

  const [openModalMultidelete, setOpenModalMultidelete] = useState(false);
  const [openModaldelete, setOpenModaldelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);
  const handleOpenModaldelete = () => {
    setOpenModaldelete(true);
  };
  const handleCloseModaldelete = () => setOpenModaldelete(false);

  const handleOpenModalMultidelete = () => {
    setOpenModalMultidelete(true);
  };
  const handleCloseModalMultidelete = () => setOpenModalMultidelete(false);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [loadingBtnUpdate, setLoadingBtnUpdate] = useState(false);
  const handleOpenConfirm = () => {
    setLoadingBtnUpdate(false);
    setOpenConfirm(true);
  };
  const handleCloseModalConfirm = () => setOpenConfirm(false);

  const handleClickModalConfirm = async () => {
    setLoadingBtnUpdate(true);
    await updateGroundingProduct();
    addLog("Product", "Confirm grounding", null);
  };

  const headCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      sortKey: "IDItem",
      label: t("grounding.table.header.code"),
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      sortKey: "itemname",
      label: t("grounding.table.header.product"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: true,
      sortKey: "model",
      label: t("grounding.table.header.model"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      sortKey: "material_Price",
      label: t("grounding.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceHome",
      label: t("grounding.table.header.priceHome"),
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceThai",
      label: t("grounding.table.header.priceThai"),
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceBoon",
      label: t("grounding.table.header.priceBoon"),
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceOth",
      label: t("grounding.table.header.priceOth"),
    },
    {
      id: "Reference",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("grounding.table.header.ref"),
    },
  ];

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  const [dataProduct, setDataProduct] = useState([]);
  const [data, setData] = useState({ total: 0 });

  React.useEffect(() => {
    if (firstLoad) {
      getData(0, rowsPerPage);
      setFirstLoad(false);
    }
  }, [dataGrounding]);

  const getData = async (nowPage, nowRowsPerPage) => {
    // Clear data
    setDataProduct([]);
    setData({ total: 0 });
    setSelected([]);

    setLoading(true);

    const role = dataAccessPermission("OWNER");

    let dataForm = {
      ID: dataGrounding,
      UserRole: role,
    };

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    qString += `&UserRole=${role}`;
    if (!firstLoad) qString += "&KeyWord=" + searchInput;

    if (!firstLoad && searchInput.length !== 0) {
      // Grounding list by word search
      await searchGroundingList(qString).then((res) => {
        if (res && res.status === 200) {
          // For paginate
          setDataProduct(res.data.data);
          setData(res.data);
        } else if (res.status === 401) {
          signOut();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.message,
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
          console.log(`error groundingProduct:`, res.data.message);
        }
        setLoading(false);
      });
    } else {
      // Grounding list by ID
      await getGroundingList(qString, dataForm).then((res) => {
        if (res && res.status === 200) {
          if (res.data.data.length > 0) {
            // For paginate
            setDataProduct(res.data.data);
            setData(res.data);
          } else {
            if (firstLoad && !listAll) {
              emptyList(false);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Grounding products successfully!",
                text: "The grounding result not found.",
                customClass: {
                  container: "my-swal-container", // Apply custom class for container
                },
              });
            }
          }
        } else if (res.status === 401) {
          signOut();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.message,
            customClass: {
              container: "my-swal-container", // Apply custom class for container
            },
          });
          console.log(`error groundingProduct:`, res.data.message);
        }
        setLoading(false);
      });
    }
  };

  const updateGroundingProduct = async () => {
    // Filter data for update
    const updData = dataProduct.filter((item) =>
      selected.includes(item.IDItem)
    );

    var dataForm = {
      upd: updData,
    };

    await updateGrounding(dataForm).then((res) => {
      if (res && res.status === 200 && res.data.success === true) {
        handleCloseModalConfirm();
        setSelected([]);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Update grounding price successfully",
          customClass: {
            container: "my-swal-container", // Apply custom class for container
          },
        });
        // Values to be removed
        const valuesToRemove = selected;

        // Remove values using filter
        const remainData = dataGrounding.filter(
          (item) => !valuesToRemove.includes(item)
        );
        setDataGrounding(remainData);
        setPage(0);
        getData(0, rowsPerPage); // Reload data
      } else if (res.status === 401) {
        signOut();
      } else {
        handleCloseModalConfirm();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.message,
        });
        console.log(`error updateGrounding:`, res.data.message);
      }
      setLoadingBtnUpdate(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && searchInput.length > 0) {
      setPage(0);
      getData(0, rowsPerPage);
    }
  };
  const handleChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleClickSearch = () => {
    setPage(0);
    getData(0, rowsPerPage);
  };

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  // Copy to clipboard
  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setOpenSnack(true);
    });
  };

  return (
    <Box>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "10px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{ width: { lg: "600px", md: "400px" }, display: "flex", mr: 2 }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              placeholder={t("grounding.txtbox.search")}
              size="middle"
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: searchInput ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearchProduct}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            />
          </Box>

          <Box>
            <Button
              onClick={handleClickSearch}
              variant="contained"
              size="small"
              sx={styleGrayBtn}
            >
              {t("common.button.search")}
            </Button>
          </Box>
        </Box>
        <Box>
          {selected.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ mr: 2 }}>
                  <Typography>
                    {t("genboq.popup.addpro.sel")}
                    {selected.length}
                    {t("genboq.popup.addpro.unit")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", mr: 2 }}>
                  <Button
                    onClick={handleOpenConfirm}
                    variant="contained"
                    size="medium"
                    style={{
                      textTransform: "none",
                      borderRadius: "10px",
                      height: "45px",
                      backgroundColor: "#7399D1",
                    }}
                  >
                    {t("common.button.confirm")}
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}
        </Box>
      </Box>

      {/*  ////////////////////////// Data Table ////////////////////////// */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: "#c4e6ff",
                }}
              >
                <Checkbox
                  checked={
                    selected.length === dataProduct.length &&
                    dataProduct.length !== 0
                  }
                  onChange={() =>
                    setSelected(
                      selected.length === dataProduct.length
                        ? []
                        : dataProduct.map((item) => item.IDItem)
                    )
                  }
                />
              </TableCell>
              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                >
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={9}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : dataProduct.length > 0 ? (
              dataProduct.map((row, index) => (
                <TableRow key={index}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selected.includes(row.IDItem)}
                      onChange={() => handleSelect(row.IDItem)}
                    />
                  </TableCell>
                  <TableCell style={{ width: 50 }} align="left">
                    <Typography>{row.IDItem}</Typography>
                  </TableCell>
                  <TableCell style={{ minWidth: "250px" }} align="left">
                    <Typography
                      sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 2, // Limits to 2 lines
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.itemname}
                    </Typography>
                  </TableCell>
                  <TableCell
                    style={{
                      minWidth: "50px",
                      maxWidth: "120px",
                    }}
                    align="left"
                  >
                    <Typography
                      sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 2, // Limits to 2 lines
                        textOverflow: "ellipsis",
                      }}
                    >
                      {row.model}
                    </Typography>
                  </TableCell>

                  <TableCell style={{ width: 150 }} align="right">
                    <Typography>
                      {NumberForm.format(row.material_Price)}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {row.matPriceHome !== null
                        ? NumberForm.format(row.matPriceHome)
                        : "Not found"}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {row.matPriceThai !== null
                        ? NumberForm.format(row.matPriceThai)
                        : "Not found"}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {row.matPriceBoon !== null
                        ? NumberForm.format(row.matPriceBoon)
                        : "Not found"}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography>
                      {row.matPriceOth !== null
                        ? row.matPriceOth2 !== null
                          ? NumberForm.format(
                              Math.min(row.matPriceOth, row.matPriceOth2)
                            )
                          : NumberForm.format(row.matPriceOth)
                        : "Not found"}
                    </Typography>
                  </TableCell>

                  <TableCell style={{ minWidth: 100 }} align="left">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {row.urlHome ? (
                        <Button
                          variant="text"
                          style={{
                            textTransform: "none",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            padding: 0,
                          }}
                          size="small"
                        >
                          <Typography
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                            sx={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              WebkitLineClamp: 1, // Limits to 1 lines
                              textOverflow: "ellipsis",
                              fontSize: "12px",
                            }}
                          >
                            <a
                              href={row.urlHome}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              HomePro
                            </a>
                          </Typography>
                        </Button>
                      ) : (
                        ""
                      )}

                      {row.urlThai ? (
                        <Button
                          variant="text"
                          style={{
                            textTransform: "none",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            padding: 0,
                          }}
                          size="small"
                        >
                          <Typography
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                            sx={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              WebkitLineClamp: 1, // Limits to 1 lines
                              textOverflow: "ellipsis",
                              fontSize: "12px",
                            }}
                          >
                            <a
                              href={row.urlThai}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              Thai watsadu
                            </a>
                          </Typography>
                        </Button>
                      ) : (
                        ""
                      )}

                      {row.urlBoon ? (
                        <Button
                          variant="text"
                          style={{
                            textTransform: "none",
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            padding: 0,
                          }}
                          size="small"
                        >
                          <Typography
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                            sx={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              WebkitLineClamp: 1, // Limits to 1 lines
                              textOverflow: "ellipsis",
                              fontSize: "12px",
                            }}
                          >
                            <a
                              href={row.urlBoon}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              Boonthavorn
                            </a>
                          </Typography>
                        </Button>
                      ) : (
                        ""
                      )}
                      {row.urlOth ? (
                        row.urlOth.startsWith("https://") ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlOth}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Other
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          <div>
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                              onClick={() => {
                                handleCopyClick(row.urlOth);
                              }}
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                Other
                              </Typography>
                            </Button>
                          </div>
                        )
                      ) : (
                        ""
                      )}
                      {row.urlOth2 ? (
                        row.urlOth2.startsWith("https://") ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlOth2}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Other2
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          <div>
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                              onClick={() => {
                                handleCopyClick(row.urlOth2);
                              }}
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                Other2
                              </Typography>
                            </Button>
                          </div>
                        )
                      ) : (
                        ""
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9}>
                  <Box
                    style={{ display: "flex", justifyContent: "center" }}
                  ></Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={10}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* /////////// Modal confirm grounding search /////////// */}
      <Modal open={openConfirm}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("grounding.popup.updategrounding.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalConfirm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("grounding.popup.updategrounding.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalConfirm}
              loading={loadingBtnUpdate}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              size="small"
            >
              {t("common.button.update")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              onClick={handleCloseModalConfirm}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
